import Vue from "vue";
import VueRouter from "vue-router";
import home from "@/views/home";
import singleCellList from "@/views/singleCell/list";
import singleCellInfo from "@/views/singleCell/detail";
import singleCellConsensus from "@/views/singleCell/consensus";
import spatialList from "@/views/spatial/list";
import spatialDetail from "@/views/spatial/detail";
import gwasList from "@/views/gwas/list";
import geneList from "@/views/gene/list";
import geneDetail from "@/views/gene/detail";
import about from "@/views/about";
import tutorial from "@/views/tutorial";
import download from "@/views/download";
import job from "@/views/job";
import log from "@/views/log";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        alias: "/home",
        component: home,
    },
    {
        path: "/singleCell/list",
        name: "singleCellList",
        component: singleCellList,
    },
    {
        path: "/singleCell/detail/:id",
        name: "singleCellDetail",
        component: singleCellInfo,
    },
    {
        path: "/singleCell/consensus",
        name: "singleCellConsensus",
        component: singleCellConsensus,
    },
    {
        path: "/spatial/list",
        name: "spatialList",
        component: spatialList,
    },
    {
        path: "/spatial/detail/:id",
        name: "spatialDetail",
        component: spatialDetail,
    },
    {
        path: "/gwas/list",
        name: "gwasList",
        component: gwasList,
    },
    // {
    //     path: "/gwas/detail/:id",
    //     name: "gwasDetail",
    //     component: gwasDetail,
    // },
    {
        path: "/gene/list",
        name: "geneList",
        component: geneList,
    },
    {
        path: "/gene/detail/:id",
        name: "geneDetail",
        component: geneDetail,
    },
    {
        path: "/about",
        name: "about",
        component: about,
    },
    {
        path: "/download",
        name: "download",
        component: download,
    },
    {
        path: "/job",
        name: "job",
        component: job,
    },
    {
        path: "/tutorial",
        name: "tutorial",
        component: tutorial,
    },
    { path: "/log", name: "log", component: log },
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});

export default router;
